



























































































































































import { Component, Vue, PropSync, Ref, Prop, Watch } from 'vue-property-decorator';
import { IRules } from '@/components/UI/Form/ValidationModule';
import SForm from '@/components/UI/Form/SForm.vue';
import { validateRequired, validateMin, validateType } from '@/components/UI/Form/Validations';
import { ALL_CURRENCIES } from '@/queries/Currency';
import { SmartQuery } from 'vue-apollo-decorator';
import { GQL_allCurrencies_allCurrencies } from '@/queries/__generated__/allCurrencies';
import { GQL_AltinnEmploymentDurationTypeEnum, GQL_AltinnEmploymentTypeEnum, GQL_AltinnShiftTypeEnum, GQL_UnitSettingBase } from '@/queries/global';
import { ALL_MUNICIPALITIES } from '@/queries/Municipality';
import { GQL_municipalities_currentUnit_municipalities, GQL_municipalities } from '@/queries/__generated__/municipalities';
import { GQL_paycheckStartNumberSet_paycheckStartNumberSet } from '@/queries/__generated__/paycheckStartNumberSet';
import Altinn from '@/app/Altinn';
import { ALL_OCCUPATIONS } from '@/queries/Occupation';
import { GQL_occupations, GQL_occupations_currentUnit_occupations } from '@/queries/__generated__/occupations';
import { GQL_currentUnitSubUnits, GQL_currentUnitSubUnits_currentUnit_subUnits } from '@/queries/__generated__/currentUnitSubUnits';
import { ALL_SUBUNITS } from '@/queries/SubUnit';
import gql from 'graphql-tag';
import Altinn3SystemUserForm from './Altinn3SystemUserForm.vue';

const PAYCHECK_START_NUMBER_SET = gql`
  query paycheckStartNumberSet {
    paycheckStartNumberSet {
      paycheckNumberSet
    }
  }
`;

@Component({
  components: {
    Altinn3SystemUserForm,
  },
})
export default class CompanyPaycheckSettingsForm extends Vue {
  @SmartQuery(ALL_CURRENCIES) private allCurrencies!: GQL_allCurrencies_allCurrencies[];
  @SmartQuery<CompanyPaycheckSettingsForm, GQL_municipalities>({
    query: ALL_MUNICIPALITIES,
    update: data => data.currentUnit.municipalities,
  }) private allMunicipalities!: GQL_municipalities_currentUnit_municipalities[];

  @SmartQuery({
    query: PAYCHECK_START_NUMBER_SET,
    fetchPolicy: 'no-cache',
  }) private paycheckStartNumberSet!: GQL_paycheckStartNumberSet_paycheckStartNumberSet;

  @SmartQuery<CompanyPaycheckSettingsForm, GQL_occupations>({
    query: ALL_OCCUPATIONS,
    update: data => data.currentUnit.occupations,
  }) private occupations!: GQL_occupations_currentUnit_occupations[];

  @SmartQuery<CompanyPaycheckSettingsForm, GQL_currentUnitSubUnits>({
    query: ALL_SUBUNITS,
    update: data => data.currentUnit.subUnits,
  }) private subUnits!: GQL_currentUnitSubUnits_currentUnit_subUnits[];


  @Prop({ type: Object, required: true }) private formData!: { unitSetting: GQL_UnitSettingBase };
  @PropSync('valid', { type: Boolean, default: true }) private validForm!: boolean;

  @Ref() private readonly formRef?: SForm;

  private shiftTypes = Object.keys(GQL_AltinnShiftTypeEnum);
  private employmentTypes = Object.keys(GQL_AltinnEmploymentTypeEnum);
  private durationTypes = Object.keys(GQL_AltinnEmploymentDurationTypeEnum);

  private rules: IRules = {
    municipality: { id: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('UnitPaycheckSetting', 'municipality') }) } ] },
    currency: { id: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: this.t_attr('UnitPaycheckSetting', 'currency') }) } ] },
    startingPaycheckNumber: [ { validation: validateRequired(), message: i18n => i18n.t('Error.required', { field: i18n.t('Company.Setting.paycheckStartNo') }) } ],
    defaultCreditDays: [ { validation: validateMin(0), message: i18n => i18n.t('Error.required', { field: this.t_attr('UnitPaycheckSetting', 'defaultCreditDays') }) } ],
    defaultVacationMoneyPercentage: [ { validation: validateType('unumber'), message: i18n => i18n.t('GQL.Type.unumber') } ],
  };

  private get isPension(): boolean {
    return this.formData.unitSetting.unitPaycheckSetting!.defaultWorkRelation!.employmentType === Altinn.pensionEmploymentType;
  }

  @Watch('isPension')
  private unsetFieldsIfIsPension(): void {
    if (this.isPension) {
      this.formData.unitSetting.unitPaycheckSetting!.defaultWorkRelation!.shiftType = null;
      this.formData.unitSetting.unitPaycheckSetting!.defaultWorkRelation!.employmentPercentage = null;
      this.formData.unitSetting.unitPaycheckSetting!.defaultWorkRelation!.hoursEveryWeekWithFullEmployment = null;
      this.formData.unitSetting.unitPaycheckSetting!.defaultWorkRelation!.durationType = null;
    }
  }

}
